// @flow
/* eslint-disable no-console */

// TODO - Have a jobApplicant property somewhere in the store

import moment from 'moment';
// Similar to the comment in i18n.js, this file is 1 kb and not worth
// trying to dynamically load. If you add a bunch more locales, though
// we should probably dynamically load them
import 'moment/locale/es';

import i18n from '../i18n';

export const initialState = {
  applied: false,
  source: null,
  sourceId: null,
  version: null,
  visitId: null,
  jobHash: null,
  jobApplicationHash: null,
  resumeFileName: null,
  job: null,
  org: null,
  person: null,
  application: null,
  applicationMethod: null,
  referralHash: null,
  referral: null,
};

type FetchApplicant = {
  resumeFileName: ?string,
  applicationMethod: string,
  jobApplicationHash: string,
  job: Job,
  org: Org,
  person: Person,
  application: Application,
};

type Visit = {
  visit_id: number,
  source_id: ?string,
  source_type: ?string,
  apply_page_version: string,
};

type JobResponse = {
  jobHash: string,
  job: Job,
}

type Action =
  | { type: 'FETCH_JOB_SUCCESS', payload: JobResponse}
  | { type: 'JOB_NOT_FOUND', payload: any}
  | { type: 'FETCH_JOB_FAILURE', payload: any}
  | { type: 'APPLY_SUCCESS', payload: ApplicantCreateAttributes}
  | { type: 'APPLY_FAILURE', payload: any}
  | { type: 'ADD_EDUCATION_HISTORY_SUCCESS', payload: EducationHistoryItemType}
  | { type: 'DELETE_EDUCATION_HISTORY_SUCCESS', payload: any}
  | { type: 'ADD_WORK_HISTORY_SUCCESS', payload: WorkHistoryItemType}
  | { type: 'DELETE_WORK_HISTORY_SUCCESS', payload: any}
  | { type: 'SAVE_APPLICATION_SUCCESS', payload: Application}
  | { type: 'SAVE_PERSON_SUCCESS', payload: Person}
  | { type: 'UPDATE_HAS_RESUME', payload: string}
  | { type: 'LOG_APPLICATION_VISIT_SUCCESS', payload: Visit}
  | { type: 'FETCH_APPLICATION_SUCCESS', payload: FetchApplicant}
  | { type: 'FETCH_REFERRAL_SUCCESS', payload: {data: ReferralType}}
  | { type: 'FETCH_REFERRAL_STARTING', payload: {args: { referralHash: number }}}
  | { type: 'REFERRAL_NOT_FOUND', payload: any}
  | { type: 'CLEAR_REFERRAL', payload: any}

export const applicationReducer = (state: Object = initialState, action: Action) => {
  let applicationCopy = null;
  let workHistoryCopy = null;
  let educationHistoryCopy = null;

  switch (action.type) {
    case 'FETCH_JOB_SUCCESS': {
      return {
        ...state,
        job: action.payload.job,
        org: action.payload.job.org,
        jobHash: action.payload.jobHash,
      };
    }
    // 404 error from the API
    case 'JOB_NOT_FOUND': {
      return { ...state, jobError: 'Sorry, this job does not exist or is no longer available.' };
    }
    case 'FETCH_JOB_FAILURE': {
      console.log('FETCH JOB FAILURE');
      console.log(action.payload);
      return { ...state, jobError: 'Sorry, there was a problem retrieving this job.' };
    }
    case 'APPLY_SUCCESS': {
      return { ...state, ...action.payload, applied: true };
    }
    case 'FETCH_APPLICATION_SUCCESS': {
      i18n.changeLanguage(action.payload.job.language || 'en');
      if (action.payload.job.language === 'es') {
        moment.locale('es');
      } else {
        moment.locale('en');
      }
      return { ...state, ...action.payload, applied: true };
    }
    case 'APPLY_FAILURE': {
      console.log('FACEBOOK APPLY FAILURE');
      console.log(action.payload);
      return state;
    }
    case 'ADD_WORK_HISTORY_SUCCESS': {
      applicationCopy = { ...state.application };
      applicationCopy.workHistory.push(action.payload);
      return { ...state, application: applicationCopy };
    }
    case 'DELETE_WORK_HISTORY_SUCCESS': {
      applicationCopy = { ...state.application };
      workHistoryCopy = state.application.workHistory.slice();
      workHistoryCopy.splice(workHistoryCopy.indexOf(action.payload), 1);
      applicationCopy.workHistory = workHistoryCopy;
      return { ...state, application: applicationCopy };
    }
    case 'ADD_EDUCATION_HISTORY_SUCCESS': {
      applicationCopy = { ...state.application };
      applicationCopy.educationHistory.push(action.payload);
      return { ...state, application: applicationCopy };
    }
    case 'DELETE_EDUCATION_HISTORY_SUCCESS': {
      applicationCopy = { ...state.application };
      educationHistoryCopy = state.application.educationHistory.slice();
      educationHistoryCopy.splice(educationHistoryCopy.indexOf(action.payload), 1);
      applicationCopy.educationHistory = educationHistoryCopy;
      return { ...state, application: applicationCopy };
    }
    case 'SAVE_APPLICATION_SUCCESS': {
      return {
        ...state,
        application: { ...state.application, ...action.payload },
      };
    }
    case 'SAVE_PERSON_SUCCESS': {
      return {
        ...state,
        person: { ...state.person, ...action.payload },
      };
    }
    case 'LOG_APPLICATION_VISIT_SUCCESS': {
      return {
        ...state,
        source: action.payload.source_type,
        sourceId: action.payload.source_id,
        visitId: action.payload.visit_id,
        version: action.payload.apply_page_version,
      };
    }
    case 'UPDATE_HAS_RESUME': {
      return { ...state, resumeFileName: action.payload };
    }
    case 'FETCH_REFERRAL_SUCCESS': {
      return { ...state, referral: action.payload.data };
    }
    case 'FETCH_REFERRAL_STARTING': {
      return { ...state, referralHash: action.payload.args.referralHash };
    }
    case 'REFERRAL_NOT_FOUND': {
      return {
        ...state,
        referral: null,
        referralError: 'Referral not found',
        source: null,
        source_id: null,
      };
    }
    case 'CLEAR_REFERRAL': {
      return {
        ...state,
        referral: null,
        referralHash: null,
        source: null,
        source_id: null,
      };
    }
    default:
      return state;
  }
};
/* eslint-enable no-console */
